import { Router } from '@angular/router';

import { Component, ViewChild, ElementRef } from '@angular/core';
import { AbstractComponent } from '../../../../../core/common/component/AbstractComponent';

import { AuthService } from 'src/app/common/service/AuthService';
import moment from 'moment';
import { Title } from '@angular/platform-browser';
import { TenantEntryDialogComponent } from './dialog/entry/TenantEntryDialogComponent';
import { TenantIndexService } from './TenantIndexService';
import { ToastrService } from 'ngx-toastr';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { TenantDeleteDialogComponent } from './dialog/delete/TenantDeleteDialogComponent';
import { MatSort } from '@angular/material/sort';


@Component({
  selector: 'app-tenant-index',
  templateUrl: './TenantIndex.html',
  styleUrls: ['./TenantIndex.scss']
})
export class TenantIndexComponent extends AbstractComponent {

  public scope = {
    wait : true,
    dataSource: null,
    displayedColumns :[ 
      'tenantName', 'tel', 
      'mainName', 'mainPosition', 'mainEmail',
      'actions']
  }

  @ViewChild(MatPaginator,  { static: true }) 
  public paginator: MatPaginator;
  @ViewChild(MatSort, {static: true})
  public sort: MatSort;


  public constructor(
    private title: Title,
    private dialog: MatDialog,
    private service : TenantIndexService,
    private toastr: ToastrService,
    private authService: AuthService, private router: Router) {
    super();
    this.title.setTitle("Tenant list");
    
  }
  /**  */
  public componentWillMount() {
  }


  /** 表示 */
  public render() {
    this.service.get().subscribe((tenants:any) => {
      this.scope.dataSource = new MatTableDataSource<any>(tenants);
      this.scope.dataSource.paginator = this.paginator;
      this.scope.dataSource.sort= this.sort;
      this.scope.wait = false;
    });
  }

  /** 表示 */
  public entryTenant() {
    const dialogRef = this.dialog.open(TenantEntryDialogComponent, {
      disableClose : true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'SUCCESS') {
        this.toastr.success('Tenant create is successful');
        this.render();
      }
    }, error => {
      console.log(error)
    });
  }
  /** delete */
  public delete(tenant) {
    const dialogRef = this.dialog.open(TenantDeleteDialogComponent, {
      disableClose : true,
      width : "500px",
      data: tenant
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.status == 'SUCCESS') {
        this.service.delete(tenant.tenantCd).subscribe(e => {
          this.toastr.success('Tenant delete is successful');
          this.render();
        });
      }
    }, error => {
      console.log(error)
    });
    // console.log('delete');
  }
  public timeFormat(date) {
    return moment(date).format('HH:mm');
  }
}
